import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

export const MovementChart = ({ daily }) => {
  const data = daily.map((d) => ({ ...d, dia: d.date.slice(8) }));
  return (
    <div data-testid="movement-chart" className="mt-4 rounded-xl border border-[#1F293D] bg-[#0F141F] p-4">
      <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-400">Testes e novas assinaturas por dia · mês atual</div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
            <CartesianGrid stroke="#1F293D" vertical={false} />
            <XAxis dataKey="dia" tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "#ffffff08" }} contentStyle={{ background: "#0B0F17", border: "1px solid #1F293D", borderRadius: 8, fontSize: 12 }}
              labelFormatter={(l) => `Dia ${l}`} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="teste" name="Testes" fill="#FBBF24" radius={[3, 3, 0, 0]} />
            <Bar dataKey="nova" name="Novas assinaturas" fill="#34D399" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
